import { render, staticRenderFns } from "./ReturnInfo.vue?vue&type=template&id=8db1b070&scoped=true&"
import script from "./ReturnInfo.vue?vue&type=script&lang=js&"
export * from "./ReturnInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReturnInfo.vue?vue&type=style&index=0&id=8db1b070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db1b070",
  null
  
)

export default component.exports